import type {BillingSubscription} from './billing-types.js';
import {decimalToAtomic} from './commerce-crypto/amount.js';

type PlanTerms={id:string|null;currency:string;unitAmount:number|null;interval:string|null;intervalCount:number|null;
  periodCreditUsd:string|null;visibility:'public'|'promotion'|null};

export function subscriptionPlanTerms(subscription:BillingSubscription):PlanTerms{
  return {id:subscription.planId,currency:subscription.currency,unitAmount:subscription.unitAmount,
    interval:subscription.interval,intervalCount:subscription.intervalCount,
    periodCreditUsd:subscription.periodCreditUsd,visibility:subscription.planVisibility};
}

/** Prices determine charges; the saved allowance determines whether a paid upgrade adds credits. */
export function billingPlanTransition(current:PlanTerms,target:PlanTerms):'unchanged'|'upgrade'|'renewal'|'unavailable'{
  if(current.id===target.id)return 'unchanged';
  if(target.visibility!=='public'||current.visibility===null||current.unitAmount===null||target.unitAmount===null||
    current.periodCreditUsd===null||target.periodCreditUsd===null||!current.interval||!current.intervalCount||
    target.currency!==current.currency||target.interval!==current.interval||target.intervalCount!==current.intervalCount)return 'unavailable';
  const currentAllowance=BigInt(decimalToAtomic(current.periodCreditUsd,9)),targetAllowance=BigInt(decimalToAtomic(target.periodCreditUsd,9));
  if(target.unitAmount>current.unitAmount&&targetAllowance>currentAllowance)return 'upgrade';
  if(current.visibility==='promotion')return targetAllowance<currentAllowance?'renewal':'unavailable';
  return target.unitAmount<current.unitAmount?'renewal':'unavailable';
}
